import Error from "next/error";
import { PureComponent } from "react";
import BbVisitorSyncComponent from "/components/pages/external/bb-visitor-sync/bb-visitor-sync-component";

const getHostName = (url) => {
  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname;
    const simplifiedHostname = hostname.replace(/^www\./, "");
    return simplifiedHostname;
  } catch (error) {
    return null;
  }
};

export default class BbVisitorSync extends PureComponent {
  static async getInitialProps({ req, res }) {
    const WHITE_LIST = new Set(["workforms.com", "mondayspaces.webflow.io", "mondayspaces.com"]);
    const source = decodeURIComponent(req?.query?.tsrc || "");
    const host = getHostName(source);
    if (!WHITE_LIST.has(host)) {
      res.statusCode = 404;
    }
    const statusCode = res.statusCode;
    return { statusCode, source };
  }

  render() {
    const { source, statusCode } = this.props;
    if (statusCode !== 200) return <Error statusCode={statusCode} />;
    return <BbVisitorSyncComponent source={source} />;
  }
}

BbVisitorSync.defaultProps = {};
